import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
// import { createLogger } from 'redux-logger'
import { routerMiddleware } from 'connected-react-router'

import { createBrowserHistory } from 'history'

import initialState from './initialState'
import createRootReducer from './reducers'
import rootSaga from './sagas'

export const history = createBrowserHistory()

export default function configureStore(resources, errorCalback) {
  const sagaMiddleware = createSagaMiddleware({ onError: errorCalback })
  // const logger = createLogger()

  // https://github.com/zalmoxisus/redux-devtools-extension
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const middlewares = process.env.REACT_APP_ENV === 'dev'
    // ? applyMiddleware(routerMiddleware(history), sagaMiddleware, logger)
    ? applyMiddleware(routerMiddleware(history), sagaMiddleware)
    : applyMiddleware(routerMiddleware(history), sagaMiddleware)

  const rootReducer = createRootReducer(history)
  const catchingReducer = (state, action) => {
    try {
      return rootReducer(state, action)
    } catch (e) {
      errorCalback(e)
      return state
    }
  }

  const store = createStore(
    catchingReducer, {
      ...initialState,
      ...resources,
    },
    composeEnhancers(middlewares),
  )

  sagaMiddleware.run(rootSaga)

  return store
}
